<ngx-slider [(value)]="Datavalue" [options]="poptions" (userChangeEnd)="update()">
</ngx-slider>
